import { render, staticRenderFns } from "./TheHomeIntroText.vue?vue&type=template&id=2e9f3af9&scoped=true&"
import script from "./TheHomeIntroText.vue?vue&type=script&lang=ts&"
export * from "./TheHomeIntroText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9f3af9",
  null
  
)

export default component.exports